/**
 * Just make sure that all lang keys equal to the `value` field
 * because we rely on that in our code
 * @param  {Object} langs
 * @return {Object}
 */
function ensureKeyEqualValue(langs) {
  // eslint-disable-next-line no-param-reassign
  Object.keys(langs).forEach((k) => (langs[k].value = k))
  return langs
}

module.exports = ensureKeyEqualValue({
  'en-us': {
    name: 'English',
    englishName: 'English',
    value: 'en-us',
    intl: 'en',
    code: 'us',
    zendeskLocale: 'en-us',
  },
  // 'en-gb': {
  //   name: 'English (UK)',
  //   value: 'en-gb',
  //   intl: 'en',
  //   code: 'gb',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'en-ca': {
  //   name: 'English (CA)',
  //   value: 'en-ca',
  //   intl: 'en',
  //   code: 'ca',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'af-za': {
  //   name: 'Afrikaans',
  //   value: 'af-za',
  //   intl: 'en',
  //   code: 'za',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'cs-cz': {
  //   name: 'čeština',
  //   value: 'cs-cz',
  //   intl: 'cs',
  //   moment: 'cs',
  //   code: 'cz',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  'de-de': {
    name: 'Deutsch',
    englishName: 'German',
    value: 'de-de',
    intl: 'de',
    moment: 'de',
    code: 'de',
    zendeskLocale: 'de',
  },
  // 'fi-fi': {
  //   name: 'Suomi',
  //   value: 'fi-fi',
  //   intl: 'fi',
  //   moment: 'fi',
  //   code: 'fi',
  //   zendeskLocale: 'fi',
  // },
  // 'hr-hr': {
  //   name: 'Hrvatski',
  //   value: 'hr-hr',
  //   intl: 'hr',
  //   moment: 'hr',
  //   code: 'hr',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  'ja-jp': {
    name: '日本語',
    englishName: 'Japanese',
    value: 'ja-jp',
    intl: 'ja',
    code: 'jp',
    zendeskLocale: 'ja',
  },
  // 'ms-my': {
  //   name: 'Bahasa Melayu',
  //   value: 'ms-my',
  //   intl: 'ms',
  //   code: 'my',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  nl: {
    name: 'Dutch',
    englishName: 'Dutch',
    value: 'nl',
    intl: 'nl',
    moment: 'nl',
    code: 'nl',
    zendeskLocale: 'nl',
  },
  // 'no-no': {
  //   name: 'Norsk',
  //   value: 'no-no',
  //   intl: 'no',
  //   code: 'no',
  //   alias: 'en-us',
  //   zendeskLocale: 'no',
  // },
  // 'pt-pt': {
  //   name: 'Português (PT)',
  //   value: 'pt-pt',
  //   intl: 'pt',
  //   moment: 'pt',
  //   code: 'pt',
  //   alias: 'pt-br',
  //   zendeskLocale: 'pt-br',
  // },
  'pt-br': {
    name: 'Português',
    englishName: 'Portuguese',
    value: 'pt-br',
    intl: 'pt',
    moment: 'pt',
    code: 'br',
    zendeskLocale: 'pt-br',
  },
  es: {
    name: 'Español',
    englishName: 'Spanish',
    value: 'es',
    intl: 'es',
    moment: 'es',
    code: 'es',
    zendeskLocale: 'es',
  },
  'tr-tr': {
    name: 'Türkçe',
    englishName: 'Turkish',
    value: 'tr-tr',
    intl: 'tr',
    moment: 'tr',
    code: 'tr',
    zendeskLocale: 'tr',
  },
  fr: {
    name: 'Français',
    englishName: 'French',
    value: 'fr',
    intl: 'fr',
    moment: 'fr',
    code: 'fr',
    zendeskLocale: 'fr',
  },
  // 'fr-ca': {
  //   name: 'Français (CA)',
  //   value: 'fr-ca',
  //   intl: 'fr',
  //   moment: 'fr',
  //   code: 'ca',
  //   alias: 'fr-fr',
  //   zendeskLocale: 'fr',
  // },
  'id-id': {
    name: 'Bahasa Indonesia',
    englishName: 'Indonesian',
    value: 'id-id',
    intl: 'en',
    code: 'id',
    zendeskLocale: 'en-us',
  },
  // 'el-gr': {
  //   name: 'ελληνικά',
  //   value: 'el-gr',
  //   intl: 'el',
  //   code: 'gr',
  //   zendeskLocale: 'el',
  // },
  'it-it': {
    name: 'Italiano',
    englishName: 'Italian',
    value: 'it-it',
    intl: 'it',
    moment: 'it',
    code: 'it',
    zendeskLocale: 'it',
  },
  // 'lt-lt': {
  //   name: 'lietuvių kalba',
  //   value: 'lt-lt',
  //   intl: 'lt',
  //   moment: 'lt',
  //   code: 'lt',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'lv-lv': {
  //   name: 'latviešu valoda',
  //   value: 'lv-lv',
  //   intl: 'lv',
  //   moment: 'lv',
  //   code: 'lv',
  //   zendeskLocale: 'en-us',
  // },
  pl: {
    name: 'Polski',
    englishName: 'Polish',
    value: 'pl',
    intl: 'pl',
    moment: 'pl',
    code: 'pl',
    zendeskLocale: 'pl',
  },
  // 'ro-ro': {
  //   name: 'limba română',
  //   value: 'ro-ro',
  //   intl: 'ro',
  //   moment: 'ro',
  //   code: 'ro',
  //   alias: 'en-us',
  //   zendeskLocale: 'ro',
  // },
  sv: {
    name: 'Svenska',
    englishName: 'Swedish',
    value: 'sv',
    intl: 'sv',
    moment: 'sv',
    code: 'sv',
    zendeskLocale: 'sv',
  },
  'ru-ru': {
    name: 'Русский',
    englishName: 'Russian',
    value: 'ru-ru',
    intl: 'ru',
    moment: 'ru',
    code: 'ru',
    zendeskLocale: 'ru',
  },
  // 'sv-se': {
  //   name: 'svenska',
  //   value: 'sv-se',
  //   intl: 'sv',
  //   moment: 'sv',
  //   code: 'se',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'tl-ph': {
  //   name: 'Tagalog',
  //   value: 'tl-ph',
  //   intl: 'tl',
  //   moment: 'tl-ph',
  //   code: 'ph',
  //   alias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  // 'uk-ua': {
  //   name: 'українська',
  //   value: 'uk-ua',
  //   intl: 'uk',
  //   code: 'ua',
  //   alias: 'ru-ru',
  //   zendeskLocale: 'ru',
  // },
  'vi-vn': {
    name: 'tiếng Việt',
    englishName: 'Vietnamese',
    value: 'vi-vn',
    intl: 'vi',
    code: 'vn',
    zendeskLocale: 'vi',
  },
  'zh-cn': {
    name: '简体中文',
    englishName: 'Simplified Chinese',
    value: 'zh-cn',
    intl: 'zh',
    code: 'cn',
    zendeskLocale: 'zh-cn',
  },
  'zh-tw': {
    name: '正體中文',
    englishName: 'Traditional Chinese',
    value: 'zh-tw',
    intl: 'zh',
    code: 'tw',
    zendeskLocale: 'zh-tw',
  },
  'ko-kr': {
    name: '한국인',
    englishName: 'Korean',
    value: 'ko-kr',
    intl: 'ko',
    code: 'kr',
    zendeskLocale: 'ko',
  },
  // 'ar-eg': {
  //   name: 'العربية',
  //   value: 'ar-eg',
  //   intl: 'ar',
  //   code: 'eg',
  //   alias: 'en-us',
  //   zendeskLocale: 'ar',
  // },
  // 'he-il': {
  //   name: 'עברית',
  //   value: 'he-il',
  //   intl: 'he',
  //   code: 'il',
  //   alias: 'en-us',
  //   zendeskLocale: 'he',
  // },
  // 'da-dk': {
  //   name: 'dansk',
  //   value: 'da-dk',
  //   intl: 'da',
  //   moment: 'da',
  //   code: 'dk',
  //   alias: 'en-us',
  //   zendeskLocale: 'da',
  // },
  // 'et-ee': {
  //   name: 'eesti',
  //   value: 'et-ee',
  //   intl: 'et',
  //   moment: 'et',
  //   code: 'ee',
  //   aslias: 'en-us',
  //   zendeskLocale: 'en-us',
  // },
  'th-th': {
    name: 'ไทย',
    englishName: 'Thai',
    value: 'th-th',
    intl: 'en',
    code: 'th',
    zendeskLocale: 'en-us',
  },
})
